import { AVAILABLE_MODELS, ModelConfig, ReasoningEffort } from "@config";
import { ArrowDropDown } from "@mui/icons-material";
import { Button, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import { ReasoningEffortSelector } from "./ReasoningEffortSelector";

interface ModelSelectorProps {
  selectedModelConfig: ModelConfig;
  onModelSelect: (modelConfig: ModelConfig) => void;
  selectedReasoningEffort?: ReasoningEffort;
  onReasoningEffortSelect?: (reasoningEffort: ReasoningEffort) => void;
}

export function ModelSelector({
  selectedModelConfig,
  onModelSelect,
  selectedReasoningEffort,
  onReasoningEffortSelect,
}: ModelSelectorProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleModelSelect = (model: ModelConfig) => {
    onModelSelect(model);
    handleClose();
  };

  const showReasoningEffortSelector =
    selectedModelConfig.reasoningEffort &&
    selectedReasoningEffort &&
    onReasoningEffortSelect;

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="text"
        size="small"
        onClick={handleClick}
        endIcon={<ArrowDropDown />}
        sx={{
          minWidth: "auto",
          fontSize: "0.75rem",
          padding: "4px 8px",
          borderColor: "rgba(0, 0, 0, 0.23)",
          color: "rgba(0, 0, 0, 0.6)",
          "&:hover": {
            borderColor: "rgba(0, 0, 0, 0.23)",
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        }}
      >
        <Typography variant="caption" sx={{ fontSize: "0.75rem" }}>
          {selectedModelConfig.displayName}
        </Typography>
      </Button>

      {showReasoningEffortSelector && (
        <ReasoningEffortSelector
          selectedReasoningEffort={selectedReasoningEffort}
          onReasoningEffortSelect={onReasoningEffortSelect}
          supportedReasoningEfforts={
            selectedModelConfig.supportedReasoningEfforts
          }
        />
      )}

      <Menu
        id="model-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "model-button",
        }}
        disablePortal
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {Object.values(AVAILABLE_MODELS).map((model) => (
          <MenuItem
            key={model.id}
            onClick={() => handleModelSelect(model)}
            selected={selectedModelConfig.id === model.id}
          >
            <div className="flex flex-col">
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {model.displayName}
              </Typography>
              {/* <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {model.provider}
              </Typography> */}
            </div>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
